import React from 'react';
import { MDBBadge, MDBCard, MDBCardBody, MDBCardText, MDBCol, MDBRow, MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';

export class CreditManagement extends React.Component {
    render() {
        return (
            <>
                <h4><b>Credit Management</b></h4>
                <MDBRow>
                    <MDBCol size="12" lg="3">
                        <MDBCard style={{}}>
                            <MDBCardBody>   
                            <MDBCardText>
                                Some quick example text to build on the card title and make
                                up the bulk of the card&apos;s content.
                            </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>
                    <MDBCol size="12" lg="3">
                        <MDBCard style={{}}>
                            <MDBCardBody>   
                            <MDBCardText>
                                Some quick example text to build on the card title and make
                                up the bulk of the card&apos;s content.
                            </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>
                    <MDBCol size="12" lg="3">
                        <MDBCard style={{}}>
                            <MDBCardBody>   
                            <MDBCardText>
                                Some quick example text to build on the card title and make
                                up the bulk of the card&apos;s content.
                            </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>
                    <MDBCol size="12" lg="3">
                        <MDBCard style={{}}>
                            <MDBCardBody>   
                            <MDBCardText>
                                Some quick example text to build on the card title and make
                                up the bulk of the card&apos;s content.
                            </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>
                </MDBRow>
                <MDBCard style={{marginTop:20}}>
                    <MDBCardBody>
                    <MDBTable responsive>
                        <MDBTableHead>
                            <tr>
                                <th>Transaction ID</th>
                                <th>Date</th>
                                <th>Total Amount(INR)</th>
                                <th>Payment Mode</th>
                                <th>Application Status</th>
                            </tr>
                        </MDBTableHead>
                        <MDBTableBody>
                            <tr>
                                <td>VIS1001</td>
                                <td>02-11-20</td>
                                <td>10,000</td>
                                <td>Credit</td>
                                <td ><MDBBadge color="none" style={{backgroundColor:'#2E3192'}}>Submitted</MDBBadge></td>
                            </tr>
                            <tr>
                                <td>VIS1001</td>
                                <td>02-11-20</td>
                                <td>10,000</td>
                                <td>Credit</td>
                                <td ><MDBBadge color="none" style={{backgroundColor:'#F58220'}}>Pending</MDBBadge></td>
                            </tr>
                            <tr>
                                <td>VIS1001</td>
                                <td>02-11-20</td>
                                <td>10,000</td>
                                <td>Credit</td>
                                <td ><MDBBadge color="success" >Approved</MDBBadge></td>
                            </tr>
                            <tr>
                                <td>VIS1001</td>
                                <td>02-11-20</td>
                                <td>10,000</td>
                                <td>Credit</td>
                                <td ><MDBBadge color="none" style={{backgroundColor:'#2E3192'}}>Submitted</MDBBadge></td>
                            </tr>
                            <tr>
                                <td>VIS1001</td>
                                <td>02-11-20</td>
                                <td>10,000</td>
                                <td>Credit</td>
                                <td ><MDBBadge color="none" style={{backgroundColor:'#2E3192'}}>Submitted</MDBBadge></td>
                            </tr>
                            <tr>
                                <td>VIS1001</td>
                                <td>02-11-20</td>
                                <td>10,000</td>
                                <td>Credit</td>
                                <td ><MDBBadge color="none" style={{backgroundColor:'#2E3192'}}>Submitted</MDBBadge></td>
                            </tr>
                            <tr>
                                <td>VIS1001</td>
                                <td>02-11-20</td>
                                <td>10,000</td>
                                <td>Credit</td>
                                <td ><MDBBadge color="none" style={{backgroundColor:'#2E3192'}}>Submitted</MDBBadge></td>
                            </tr>
                            <tr>
                                <td>VIS1001</td>
                                <td>02-11-20</td>
                                <td>10,000</td>
                                <td>Credit</td>
                                <td ><MDBBadge color="none" style={{backgroundColor:'#2E3192'}}>Submitted</MDBBadge></td>
                            </tr>    
                        </MDBTableBody>
                        </MDBTable>
                        </MDBCardBody>
                    </MDBCard>
            </>
        )
    }
}

export default CreditManagement
